// import { config, handleResponse, addUser, removeUser, getUser } from '../../_helpers';
import { config, handleResponse, addUser, getUser } from '../../_helpers';
export const userService = {
    getAllUsers,
    getUserById,
    createUser,
    updateUser,
    deleteUser,
    activation,
    setup,
    login,
    logout,
    getLoginUser,
    resendEmail,
    helpSupport,
    changePassword,
    changePasswordAdmin,

    updateUserCy,
    updateUserBranch,

    getCurrentVersion,
};

function getCurrentVersion(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Users/getCurrentSystemVersion/${id}`, requestOptions).then(handleResponse);
}

function getAllUsers(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/users/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/users/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getUserById(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/users/${id}`, requestOptions).then(handleResponse);
}
function createUser(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify([payload]),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/users/multipleInsert`, requestOptions).then(handleResponse);
}
function updateUser(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify([payload]),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/users/update/${id}`, requestOptions).then(handleResponse);
}
function updateUserCy(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Users/updateUserCy/${id}`, requestOptions).then(handleResponse);
}
function updateUserBranch(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Users/updateUserBranch/${id}`, requestOptions).then(handleResponse);
}
function deleteUser(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/users/delete`, requestOptions).then(handleResponse);
}
function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/users/activation/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function setup(userId, token, password) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            token: token,
            password: password
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    const fetchurl = `${config.apiUrl}/users/setup/${userId}`;
    console.log('fetchurl', fetchurl);
    return fetch(fetchurl, requestOptions).then(handleResponse)
}
function login(userId, password) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            userId: userId,
            password: password
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/users/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user[0].token) {
                // store user details and jwt token in indexed storage to keep user logged in between page refresh
                addUser({...user[0], devicelogin: new Date()});
            }

            return user[0];
        });
}
function logout(id) {
    // remove user from local storage to log user out
    // return removeUser(id);
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Users/logOut`, requestOptions).then(handleResponse);
}
function getLoginUser() {
    return getUser().then((user) => {
        return user;
    });
}
function resendEmail(id, template) {
    const requestOptions = {
        method: 'POST'
    };
    return fetch(`${config.apiUrl}/Users/sendEmail/${id}?template=${template}`, requestOptions).then(handleResponse);
}
function helpSupport(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/users/HelpSupport`, requestOptions).then(handleResponse);
}
function changePassword(user) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Users/changePassword/${user.userId}?oldPass=${user.oldPassword}&password=${user.newPassword}`, requestOptions).then(handleResponse);
}
function changePasswordAdmin(user) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Users/ChangePasswordAdmin/${user.userId}?password=${user.newPassword}`, requestOptions).then(handleResponse);
}